<template>
  <b-row>
   
    <b-col cols="12" class="mb-2">
      <PageTitle title="Relatório clicks nos meus contatos" />  
    </b-col>
    
    <b-col cols="12" class="my-4"> 
      <b-row>
        <div class="col-sm-12 col-md-4 col-lg-5 mt-4">
            <label>Data Início</label>
            <input type="date" class="form-control" v-model="fields.dateStart">
          </div>
          <div class="col-sm-12 col-md-4 col-lg-5 mt-4">
            <label>Data Fim</label>
            <input type="date" class="form-control" v-model="fields.dateEnd">
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2 mt-4 d-flex flex-column">
            <button
              class="btn btn-success btn-block mt-auto"
              @click="getClicks()"
            >
              Filtrar
            </button>
          </div>
      </b-row>
    </b-col>

    <b-col v-for="(item, key) in items" :key="key" cols="12" md="4">
      <ReportQuantityCard
        icon="fas fa-user"
        :text="item.name"
        :quantity="item.quantity"
        :type="item.id_type"
        class="mt-3"
      />
    </b-col>
   
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import ReportQuantityCard from '@/components/Cards/ReportQuantityCard.vue';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ReportLinktreeClicks',
  mixins: [makeToast],

  components: {
    PageTitle,
    ReportQuantityCard
  },

  data() {
    return {
      items: [],
      fields: {
        startDate: '',
        endDate: '',
      }
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.getClicks();
  },

  methods: {
    getClicks() {
      this.item = [];

      const data = {
        dateStart: this.fields.dateStart,
        dateEnd: this.fields.dateEnd,
        userId: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getLinktreeClicks', data)
        .then((response) => {
          this.items = response.data.data;
        })
        .catch(() => {
          this.makeToast('Ops!', 'Não foi possível buscar os clicks!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
}
</script>


